module.exports = __webpack_public_path__ + "img/251107_9_delivery_event_winner.09a1607e.png";